import styled from 'styled-components'

import { Skeleton } from '@root/shared/ui-kit'

import { COMMENT_ITEM_AVATAR_SIZE } from './consts'

export const CommentItemSkeleton = () => (
  <Root>
    <Header>
      <Skeleton
        width={COMMENT_ITEM_AVATAR_SIZE}
        height={COMMENT_ITEM_AVATAR_SIZE}
        variant="circular"
      />
      <HeaderGroup>
        <Skeleton width={200} height={12} />
        <Skeleton width={70} height={12} />
      </HeaderGroup>
    </Header>
    <Text>
      <Skeleton height={40} />
    </Text>
    <Reactions>
      <Like width={32} height={20} />
      <Like width={32} height={20} />
    </Reactions>
  </Root>
)

const Root = styled.div`
  padding-bottom: 10px;
`

const Header = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
`

const HeaderGroup = styled.div`
  border-bottom: 1px solid var(--background-3);

  display: grid;
  grid-template-columns: auto 1fr;
  align-content: center;
  justify-items: end;

  gap: 10px;
  height: 24px;
`

const Text = styled.div`
  display: grid;
  position: relative;

  gap: 8px;
  margin-top: 10px;
  padding-inline-start: 30px;
`

const Reactions = styled.div`
  display: grid;
  position: relative;

  gap: 8px;
  grid-template-columns: auto auto;
  justify-content: start;
  margin-top: 10px;
  padding-inline-start: 30px;
`

const Like = styled(Skeleton)`
  border-radius: 20px;
`
